import { useMemo } from "react";

export function useTableHeaderStyle(menusHeight) {
  return useMemo(() => {
    return {
      top: menusHeight - 1,
    };
  }, [menusHeight]);
}
